import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductVariant } from '../../interfaces/wheels';
import { WheelRouteDetectionService, RouteInfo } from '../../services/wheel-route-detection.service';
import { CartItem } from '../../services/wheel-cart.service';

@Component({
  selector: 'app-wheel-size-selection-manager',
  templateUrl: './wheel-size-selection-manager.component.html',
  styleUrls: ['./wheel-size-selection-manager.component.scss']
})
export class WheelSizeSelectionManagerComponent implements OnInit, OnChanges {
  @Input() product: ProductVariant;
  @Input() vehicleWheels: ProductVariant[];
  @Input() checkfitment: boolean = false;
  @Input() queryParams: any;
  @Output() onCartItemsChange = new EventEmitter<CartItem[]>();
  @Output() onPriceChange = new EventEmitter<number>();

  routeInfo: RouteInfo;
  selectedComponent: 'regular' | 'search-by-size' | 'staggered' = 'regular';

  constructor(
    private route: ActivatedRoute,
    private wheelRouteDetectionService: WheelRouteDetectionService
  ) { }

  ngOnInit(): void {
    this.detectRouteAndComponent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.queryParams) {
      this.detectRouteAndComponent();
    }
  }

  /**
   * Detects the current route and determines which component to use
   */
  private detectRouteAndComponent(): void {
    this.routeInfo = this.wheelRouteDetectionService.detectRouteInfo(this.route, this.queryParams);
    this.selectedComponent = this.wheelRouteDetectionService.getSizeSelectionComponent(this.routeInfo);
  }

  /**
   * Handles cart items change from child components
   */
  handleCartItemsChange(items: CartItem[]): void {
    this.onCartItemsChange.emit(items);
  }

  /**
   * Handles price change from child components
   */
  handlePriceChange(price: number): void {
    this.onPriceChange.emit(price);
  }

  /**
   * Gets whether we should show the search-by-size selector
   */
  shouldShowSearchBySize(): boolean {
    return this.selectedComponent === 'search-by-size' || this.selectedComponent === 'staggered';
  }

  /**
   * Gets whether we should show the regular selector
   */
  shouldShowRegular(): boolean {
    return this.selectedComponent === 'regular';
  }

  /**
   * Gets debug information for development
   */
  getDebugInfo(): any {
    return {
      routeInfo: this.routeInfo,
      selectedComponent: this.selectedComponent,
      queryParams: this.queryParams,
      checkfitment: this.checkfitment
    };
  }
}
